// var Bloodhound = require(['corejs-typeahead'], function (typeahead) {});
var Midttrafik2016 = Midttrafik2016 || {};

Midttrafik2016.routeListTypeahead = function (el, routeList) {
    $(el).typeahead('destroy');

    var routeList = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('LineDisplayText'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        local: routeList
    });

    $(el).typeahead(
        {
            minLength: 1,
        },
        {
            name: "routeList",
            source: routeList,
            display: 'LineDisplayText',
            limit: 25,
            templates: {
                empty: [
                    '<div class="empty-message">',
                    'Din søgning gav ingen resultater',
                    '</div>'
                ].join('\n')
            },
        }
    );
};
